import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { scrollToTop, refreshScrollTriggers } from "./lib/motion";
import { Layout } from "./components/Layout/Layout";
import { HomePage } from "./pages/Home/HomePage";
import { BookStayPage } from "./pages/BookStay/BookStayPage";
import { BookEventPage } from "./pages/BookEvent/BookEventPage";
import { GalleryPage } from "./pages/Gallery/GalleryPage";
import { FaqPage } from "./pages/Faq/FaqPage";
import { ContactPage } from "./pages/Contact/ContactPage";
import { NotFoundPage } from "./pages/NotFound/NotFoundPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollToTop(true);
    // Content changed — let ScrollTrigger recompute after paint.
    const id = window.setTimeout(refreshScrollTriggers, 240);
    return () => window.clearTimeout(id);
  }, [pathname]);
  return null;
}

export function App() {
  return (
    <Layout>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/book-a-stay" element={<BookStayPage />} />
        <Route path="/book-an-event" element={<BookEventPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
}
